import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ClockFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M8.2213 2.36358C9.42242 1.86606 10.7098 1.60999 12.0099 1.60999C14.6355 1.60999 17.1536 2.65302 19.0102 4.50963C20.8668 6.36624 21.9099 8.88434 21.9099 11.51C21.9099 14.1356 20.8668 16.6537 19.0102 18.5103C17.1536 20.367 14.6355 21.41 12.0099 21.41C10.7098 21.41 9.42242 21.1539 8.2213 20.6564C7.02017 20.1589 5.92881 19.4296 5.00951 18.5103C4.09021 17.591 3.36098 16.4997 2.86346 15.2986C2.36593 14.0974 2.10986 12.8101 2.10986 11.51C2.10986 10.2099 2.36593 8.92254 2.86346 7.72142C3.36098 6.5203 4.09021 5.42893 5.00951 4.50963C5.92881 3.59033 7.02017 2.8611 8.2213 2.36358ZM12.3097 6.52002C12.3097 6.02296 11.9067 5.62002 11.4097 5.62002C10.9126 5.62002 10.5097 6.02296 10.5097 6.52002V12.12C10.5097 12.6171 10.9126 13.02 11.4097 13.02H16.0597C16.5567 13.02 16.9597 12.6171 16.9597 12.12C16.9597 11.623 16.5567 11.22 16.0597 11.22H12.3097V6.52002Z" fill="currentColor" /></Svg>;
}
export default ClockFill;